import React, { useState, useEffect, useRef } from "react";
import { useLocation } from 'react-router-dom';
import axios from "../../../../axios-order";
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useHistory } from 'react-router-dom';
import ToggleSwitch from "../../../../components/ui/ToggleSwitch/ToggleSwitch";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import TurnedInNotIcon from '@mui/icons-material/TurnedInNot';
import { makeStyles } from "@material-ui/core/styles";
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import MuiAlert from "@material-ui/lab/Alert";
import { Chip } from '@mui/material';
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import {
    DataGridPro,
    useGridApiRef,
    gridFilteredSortedRowEntriesSelector,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarQuickFilter,
    GridToolbarDensitySelector
} from '@mui/x-data-grid-pro';
import {
    Modal,
    Box,
    Typography,
    Button,
    Tooltip,
    CircularProgress,
    IconButton,
    Checkbox,
    ListItemText,
    TablePagination,
    Snackbar, Alert
} from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import RefreshIcon from '@mui/icons-material/Refresh';


const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh", // Ensure the parent takes full viewport height
        width: "100%", // Ensure the parent spans the full width
        position: "relative",
    },
    uploadSection: {
        background: "transparent",
        borderRadius: "15px",
        padding: theme.spacing(4),
        boxShadow: "0 8px 30px rgba(0, 0, 0, 0.12)",
        maxWidth: "500px",
        width: "100%", // This is fine, as maxWidth limits it
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(3),
        border: "2px dashed #007bff",
        borderColor: "#007bff",
        // Remove redundant borderStyle
        margin: "auto", // Helps with horizontal centering
    },
    fileInput: {
        display: "none",
    },
    fileName: {
        color: "#444",
        fontSize: "0.95rem",
        fontWeight: "bold",
        wordBreak: "break-word",
        textAlign: "center",
    },
    uploadButtonInput: {
        background: "linear-gradient(90deg, #4a90e2, #007aff)",
        color: "#fff",
        fontWeight: 700,
        padding: theme.spacing(1.5, 4),
        borderRadius: "30px",
        textTransform: "uppercase",
        fontSize: "1.1rem",
        transition: "all 0.3s ease",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&:hover": {
            background: "linear-gradient(90deg, #007aff, #4a90e2)",
            transform: "scale(1.05)",
            boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
        },
    },
    uploadButton: {
        background: "linear-gradient(90deg, #4a90e2, #007aff)",
        color: "#ffffff",
        fontWeight: 700,
        padding: theme.spacing(1.5, 4),
        borderRadius: "30px",
        textTransform: "uppercase",
        fontSize: "1.1rem",
        transition: "all 0.3s ease",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&:hover": {
            background: "linear-gradient(90deg, #2ecc71, #1abc9c)",
            transform: "scale(1.05)",
            boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
        },
    },
    icon: {
        marginRight: theme.spacing(1),
    },
    leftIconButtonsContainer: {
        position: "absolute",
        left: "16px",
        display: "flex",
        gap: theme.spacing(2),
    },
    rightIconButtonsContainer: {
        position: "absolute",
        right: "16px",
        display: "flex",
        gap: theme.spacing(2),
    },
}));

const columns = (handleStatusChange, recordStatuses) => [
    {
        field: 'record_type',
        headerName: 'Record Type',
        flex: 1,
        minWidth: 150,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'legal_name',
        headerName: 'Legal Name',
        flex: 1,
        minWidth: 150,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'stin',
        headerName: 'GSTIN',
        flex: 1,
        minWidth: 200,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'inum',
        headerName: 'Invoice Number',
        flex: 0.7,
        minWidth: 120,
        pinned: 'left',
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'inv_typ',
        headerName: 'Invoice Type',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'idt',
        headerName: 'Invoice Date',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'val',
        headerName: 'Invoice Value',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'rtnprd',
        headerName: 'Source Return Period',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'srcfilstatus',
        headerName: 'Source Filing Status',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'action',
        headerName: 'Status',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
        renderCell: (params) => {
            // Display the status from recordStatuses, falling back to the original action value
            const displayStatus = recordStatuses[params.row.ID] || params.row.action || '';
            return <span>{displayStatus}</span>;
        },
    },

];



const CustomToolbar = ({ }) => (
    <Box
        sx={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            height: '60px',
            flexWrap: 'wrap',
            gap: 1,
            padding: '3px 10px',
            backgroundColor: '#ffffff',
            borderRadius: '4px',
            boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
        }}
    >
        <Box sx={{ display: 'flex', gap: 1 }}>
            <GridToolbarColumnsButton
                sx={{
                    borderColor: '#1976d2',
                    color: '#1976d2',
                    borderRadius: '4px',
                    padding: '2px 4px',
                    '&:hover': { borderColor: '#1565c0', backgroundColor: '#e3f2fd' },
                }}
            />
            <GridToolbarFilterButton
                sx={{
                    borderColor: '#1976d2',
                    color: '#1976d2',
                    borderRadius: '4px',
                    padding: '2px 4px',
                    '&:hover': { borderColor: '#1565c0', backgroundColor: '#e3f2fd' },
                }}
                PopperProps={{
                    style: { zIndex: 1300 },
                }}
            />
            <GridToolbarDensitySelector
                sx={{
                    borderColor: '#1976d2',
                    color: '#1976d2',
                    borderRadius: '4px',
                    padding: '2px 4px',
                    '&:hover': { borderColor: '#1565c0', backgroundColor: '#e3f2fd' },
                }}
            />
        </Box>

    </Box>
);

const CustomNoRowsOverlay = () => {
    console.log('Rendering CustomNoRowsOverlay');
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                fontSize: '16px',
                fontWeight: 'medium',
                color: 'text.secondary',
            }}
        >
            No Data Available
        </Box>
    );
};


const LogTable = ({ recordForLogTable, loaderForTable, getManualLog, handleActionClick }) => {
    const recordsWithId = recordForLogTable.map((row, index) => ({
        ...row,
        id: `${row.uploaded_datetime}_${row.type}_${index}`,
    }));

    return (
        <TableContainer component={Paper}
            sx={{
                marginTop: 2,
                maxHeight: 400, // Ensure this is set for scrolling
                overflow: 'auto', // Enable scrolling
                '& .MuiTableHead-root': {
                    position: 'sticky', // Explicitly set sticky for header
                    top: 0,
                    zIndex: 1, // Ensure header stays above body
                    backgroundColor: '#607d8b', // Moved background color here for clarity
                },
            }}
        >
            <Table stickyHeader
                aria-label="customized table"
                sx={{
                    borderRadius: '20px',
                    '& .MuiTableCell-root': {
                        padding: '10px 16px',
                        fontSize: '0.9rem',
                    },
                }}
                size="medium"
            >
                <TableRow sx={{ backgroundColor: '#607d8b' }}>
                    <TableCell
                        sx={{
                            color: '#ffffff',
                            // fontWeight: 'bold',
                            fontFamily: `'Montserrat', sans-serif', 'Roboto', sans-serif`,
                            fontSize: '1rem',
                            letterSpacing: '0.05rem',
                            textTransform: 'uppercase',
                        }}
                        align="center"
                    >
                        TYPE
                    </TableCell>
                    <TableCell
                        sx={{
                            color: '#ffffff',
                            fontWeight: 'bold',
                            fontFamily: `'Montserrat', sans-serif', 'Roboto', sans-serif`,
                            fontSize: '1rem',
                            letterSpacing: '0.05rem',
                            textTransform: 'uppercase',
                        }}
                        align="center"
                    >
                        UPLOAD TIME
                    </TableCell>
                    <TableCell
                        sx={{
                            color: '#ffffff',
                            fontWeight: 'bold',
                            fontFamily: `'Montserrat', sans-serif', 'Roboto', sans-serif`,
                            fontSize: '1rem',
                            letterSpacing: '0.05rem',
                            textTransform: 'uppercase',
                        }}
                        align="center"
                    >
                        STATUS
                    </TableCell>
                    <TableCell
                        sx={{
                            color: '#ffffff',
                            fontWeight: 'bold',
                            fontFamily: `'Montserrat', sans-serif', 'Roboto', sans-serif`,
                            fontSize: '1rem',
                            letterSpacing: '0.05rem',
                            textTransform: 'uppercase',
                        }}
                        align="center"
                    >
                        ACTION
                    </TableCell>
                </TableRow>
                <TableBody>
                    {recordsWithId.length > 0 ? (
                        recordsWithId.map((row, index) => (
                            <TableRow key={row.id}>
                                <TableCell sx={{ fontWeight: 'bold' }} align="center">
                                    {row.type}
                                </TableCell>
                                <TableCell align="center">{row.uploaded_datetime}</TableCell>
                                <TableCell align="center">
                                    <Chip
                                        label={row.status}
                                        color={row.status === 'Pass' ? 'success' : 'error'}
                                        variant="outlined"
                                        sx={{
                                            height: 32,
                                            borderRadius: '16px',
                                            width: 80,
                                        }}
                                    />
                                </TableCell>
                                <TableCell align="center">
                                    <VisibilityOutlinedIcon
                                        className="action-icon-button showIcon"
                                        onClick={() => handleActionClick(row.action)}
                                    // style={{ color: v.upload_status === "Success" ? "#2938c2" : "#b4bfbf" }}
                                    />
                                </TableCell>
                            </TableRow>
                        ))
                    ) : (
                        <TableRow>
                            <TableCell colSpan={4} align="center" sx={{ fontWeight: 'bold' }}>
                                No data found!
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

const IMSReport = ({ recordForTable, loaderForTable, getApiImsReport, activeTab, gridApiRef }) => {
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'info',
    });

    // State to track dropdown selections (stores human-readable values: Accepted, Pending, Rejected, or '')
    const [recordStatuses, setRecordStatuses] = useState(
        recordForTable.reduce((acc, row) => {
            // Use the action value directly from the API response
            acc[row.ID] = row.action || ''; // Default to empty string if no action
            return acc;
        }, {})
    );

    // Sync recordStatuses when recordForTable changes
    useEffect(() => {
        setRecordStatuses((prev) =>
            recordForTable.reduce((acc, row) => {
                // Preserve the API's action value or use the previous status if it exists
                acc[row.ID] = prev[row.ID] || row.action || '';
                return acc;
            }, {})
        );
    }, [recordForTable]);

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };

    // Handler for status change
    const handleStatusChange = (id, newStatus) => {
        console.log('handleStatusChange - ID:', id, 'New Status:', newStatus);
        setRecordStatuses((prev) => ({
            ...prev,
            [id]: newStatus,
        }));
    };

    const handleSubmit = async () => {
        const payload = {
            business_entity_id: '2179',
            records: recordForTable.map((row) => ({
                record_type: row.record_type,
                ID: row.ID,
                stin: row.stin,
                inum: row.inum,
                inv_typ: row.inv_typ,
                action: recordStatuses[row.ID] || 'P', // Default to P if no status selected
                srcform: row.srcform || 'R1',
                rtnprd: row.rtnprd,
                idt: row.idt,
                val: row.val,
                pos: row.pos || '29',
                txval: row.txval || row.val,
                iamt: row.iamt || 0,
                camt: row.camt || 0,
                samt: row.samt || 0,
                cess: row.cess || 0,
            })),
        };

        try {
            const res = await axios.post('/push_to_ims_portal', payload);
            console.log('IMS Accepted Report Response:', res.data);
            setSnackbar({
                open: true,
                message: 'Records submitted successfully',
                severity: 'success',
            });
            if (getApiImsReport) {
                await getApiImsReport();
            }
        } catch (error) {
            console.error('Error submitting IMS records:', error);
            setSnackbar({
                open: true,
                message: error.response?.data?.message || 'Error submitting IMS records',
                severity: 'error',
            });
        }
    };

    return (
        <>
            <Box sx={{ height: '65vh', width: '100%', marginTop: '4px' }}>
                <DataGridPro
                    rows={recordForTable}
                    columns={columns(handleStatusChange, recordStatuses)}
                    getRowId={(row) => row.ID}
                    loading={loaderForTable}
                    apiRef={gridApiRef}
                    disableRowSelectionOnClick
                    onRowSelectionModelChange={() => { }}
                    sx={{
                        maxHeight: '65vh',
                        '& .MuiDataGrid-columnHeaders': {
                            color: '#fff',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                            textAlign: 'right',
                            zIndex: 1000,
                        },
                        '& .MuiDataGrid-columnHeader': {
                            position: 'relative',
                            textAlign: 'right',
                            width: '100%',
                            fontWeight: 'bold',
                            backgroundColor: '#607d8b',
                        },
                        '& .MuiDataGrid-columnHeaderTitle': {
                            color: '#fff',
                        },
                        '& .MuiDataGrid-sortIcon': {
                            opacity: 'inherit !important',
                        },
                        '& .MuiDataGrid-iconButtonContainer': {
                            visibility: 'visible',
                        },
                        '& .MuiDataGrid-menuIconButton': {
                            opacity: '1 !important',
                            visibility: 'visible !important',
                            display: 'flex !important',
                        },
                        '& .MuiDataGrid-columnHeaderIcon': {
                            color: '#fff',
                        },
                        '& .MuiDataGrid-columnHeader .MuiIconButton-root': {
                            color: '#fff',
                        },
                        '& .MuiDataGrid-row:nth-of-type(odd)': {
                            backgroundColor: '#f9f9f9',
                        },
                        '& .MuiDataGrid-row:nth-of-type(even)': {
                            backgroundColor: '#ffffff',
                        },
                        '& .MuiDataGrid-cell': {
                            padding: '8px',
                            textAlign: 'center',
                        },
                        '& .MuiDataGrid-footerContainer': {
                            backgroundColor: '#f0f0f0',
                        },
                        '& .MuiCheckbox-root': {
                            color: '#1976d2',
                        },
                        '& .MuiDataGrid-row:hover': {
                            backgroundColor: '#d3e3fc',
                            cursor: 'pointer',
                        },
                    }}
                    components={{
                        Toolbar: () => <CustomToolbar activeTab={activeTab} onSubmit={handleSubmit} />,
                        NoRowsOverlay: CustomNoRowsOverlay,
                    }}
                />
            </Box>
            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>

            {/* <Snackbar
                open={snackbarOpen}
                autoHideDuration={4000}
                onClose={() => setSnackbarOpen(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                TransitionProps={{
                    timeout: 500, // animation time (fade in/out)
                    onExit: () => setSnackbarOpen(false),
                }}
            >
                <Alert onClose={() => setSnackbarOpen(false)} severity={snackbarSeverity} sx={{ width: "100%" }}>
                    {message}
                </Alert>
            </Snackbar> */}
        </>
    );
};



export default function IMSReconManualPairing() {
    let history = useHistory();
    const classes = useStyles();
    const [upload26AS, setUpload26AS] = useState(false)
    const [recordForTable, setRecordForTable] = useState([]);
    const [recordForLogTable, setRecordForLogTable] = useState([]);
    const [loaderForTable, setLoaderForTable] = useState(false);
    const [reconId, setReconId] = useState(null);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [exportButtonLaoding, setExportButtonLaoding] = useState(false);
    const [fileName, setFileName] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileDataToUpload, setFileDataToUpload] = useState("");
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [summaryrecords, setSummaryrecords] = useState([]);
    const [pairIdSrNum, setPairIdSrNum] = useState(localStorage.getItem("max_pair_id") || 0)
    const location = useLocation();
    const reconid = location.state?.reconid;
    const gridApiRef = useGridApiRef();
    const [selectedAction, setSelectedAction] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");
    const [responseMessage, setResponseMessage] = useState("");
    const [refresh, setRefresh] = useState(false);
    const [refreshLoading, setRefreshLoading] = useState(false);
    // const recon_Id = location.state?.reconid;


    console.log(reconid);

    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'info'
    });
    const [pagination, setPagination] = useState({
        page: 0, // 0-based for TablePagination
        rowsPerPage: 10, // Set to 10 as requested
        total_count: 0,
        total_pages: 1,
    });


    const handleActionClick = (action) => {
        console.log(action);
        setSelectedAction(action);
        setSnackbarOpen(true);
        setSnackbar({
            open: true,
            message: action,
            severity: action === 'Initiated' || action === 'Failed' ? 'error' : 'success'
        });
    }

    // const handleRemarkClick = (remark) => {
    //     setSelectedRemark(remark || 'No remark available');
    //     setSnackbarOpen(true);
    // };

    const handleToggleChange = () => {
        const newUpload26AS = !upload26AS;
        setUpload26AS(newUpload26AS);
        if (newUpload26AS) {
            getManualLog();
        }
    };

    const handlePageChange = (event, newPage) => {
        setPagination((prev) => ({ ...prev, page: newPage }));
    };

    const handleRowsPerPageChange = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        setPagination((prev) => ({
            ...prev,
            page: 0, // Reset to first page
            rowsPerPage: newRowsPerPage,
        }));
    };

    const handleFileChange = (e) => {
        if (e.target.files.length) {
            const file_data = e.target.files[0];
            let fileName = file_data.name;
            setFileName(fileName)
            setSelectedFile(file_data);
            const reader = new FileReader();
            reader.readAsDataURL(file_data);
            reader.onload = function () {
                let file_value = reader.result;
                setFileDataToUpload(file_value);
            };
            e.target.value = null;
        }
    };

    const handleFileUpload = () => {
        if (!selectedFile) {
            setSnackbar({
                open: true,
                message: "Please select a file first.",
                severity: "error",
            });
            return;
        }

        const payLoadData = {
            "business_entity_id": localStorage.getItem("business_entity_id"),
            // "financial_year": '',
            "file": fileDataToUpload,
            "document_name": fileName,
            "ims_recon_id": reconid,
            // "max_pair_id": localStorage.getItem("max_pair_id")
        }

        setIsLoading(true);
        axios
            .post("/manual_pair_upload_summary", payLoadData)
            .then((response) => {
                if (response?.data?.message) {
                    setMessage(response?.data?.message);
                    // setSnackbarOpen(true);
                }
                getManualLog();
            })
            .catch((error) => {
                setMessage("Error uploading file.");
                setSnackbarOpen(true);
            }).finally(() => {
                setSelectedFile(null);
                setFileDataToUpload("")
                setIsLoading(false);
            });
    };

    const handleSnackbarOpen = (message, severity) => {
        setSnackbarOpen(true);
        setSnackbarSeverity(severity);
        setMessage(message);
    };



    const downloadBase64File = (contentType, base64Data, fileName) => {
        const linkSource = `data:${contentType};base64,${base64Data}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    };


    const getVisibleRows = () => {
        if (!gridApiRef.current) {
            console.warn('gridApiRef.current is undefined');
            return [];
        }
        const visibleRows = gridFilteredSortedRowEntriesSelector(gridApiRef);
        return visibleRows.map(item => item.model);
    };


    const handleExportExcel = (item = null) => {
        const payLoadData = {
            "business_entity_id": localStorage.getItem("business_entity_id"),
            "ims_recon_id": reconid,
            // "financial_year": financial_year,
            // "entity_type": localStorage.getItem("entity_type")
        }
        if (item) {
            setRecordForTable(prevRecords =>
                prevRecords.map(record =>
                    record.id === item.id ? { ...record, excel_loading: true } : record
                )
            );
        } else {



            setExportButtonLaoding(true)
        }

        const visibleRows = getVisibleRows(gridApiRef);
        payLoadData['frontend_records'] = visibleRows

        const contentType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const filename = 'IMS Manual.xlsx'


        axios
            .post(`/manual_pair_excel_report`, payLoadData)
            .then((res) => {
                if (res?.data?.file) {
                    downloadBase64File(contentType, res?.data?.file, filename);
                }
            })
            .catch((error) => {
                console.log(error);
            }).finally(() => {
                if (item) {
                    setRecordForTable(prevRecords =>
                        prevRecords.map(record =>
                            record.id === item.id ? { ...record, excel_loading: false } : record
                        )
                    );
                } else {
                    setExportButtonLaoding(false)
                }
            });
    }


    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
        setSnackbarSeverity("success");
        setResponseMessage("");
    };


    const getManualLog = () => {
        const business_entity_id = localStorage.getItem("business_entity_id");
        axios
            .get(`/ims_recon_upload_logs/${business_entity_id}`)
            .then((res) => {
                console.log("IMS Report Response:", res.data);
                if (res.data.status && Array.isArray(res.data.data)) {

                    const recordsWithId = res.data.data.map((record, index) => ({
                        ...record,
                        id: `${record.uploaded_datetime}_${record.type}_${index}`,
                    }));
                    setRecordForLogTable(recordsWithId);
                    // setSnackbar({
                    //     open: true,
                    //     message: res.data.message,
                    //     severity: 'success',
                    // });
                } else {
                    setSnackbar({
                        open: true,
                        message: "Invalid API response: Expected records array",
                        severity: 'error',
                    });
                }
                setLoaderForTable(false);
            })
            .catch((error) => {
                console.error("Error fetching IMS report summary:", error);
                setLoaderForTable(false);
                setSnackbar({
                    open: true,
                    message: error.response?.data?.message || "Error fetching IMS report summary",
                    severity: 'error',
                });
            });
    };


    useEffect(() => {
        getApiImsRepository(reconid, pagination.page, pagination.rowsPerPage);
    }, []);

    const getApiImsRepository = (reconid, page = 0, rowsPerPage = 10) => {
        const business_entity_id = localStorage.getItem("business_entity_id")
        setLoaderForTable(true);
        axios
            .get(`/ims_report_summary/${reconid}/${business_entity_id}`)
            .then((res) => {
                console.log("IMS Report Response:", res.data);
                if (res.data.status && Array.isArray(res.data.records)) {
                    setRecordForTable(res.data.records);
                    // setSnackbar({
                    //     open: true,
                    //     message: res.data.message,
                    //     severity: 'success'
                    // });
                    // setPagination({
                    //     page: res.data.pagination.page - 1, // Convert to 0-based
                    //     rowsPerPage: res.data.pagination.per_page,
                    //     total_count: res.data.pagination.total_count,
                    //     total_pages: res.data.pagination.total_pages,
                    // });
                } else {
                    setSnackbar({
                        open: true,
                        message: "Invalid API response: Expected records array",
                        severity: 'error'
                    });
                }
                setLoaderForTable(false);
            })
            .catch((error) => {
                console.error("Error fetching IMS report summary:", error);
                setLoaderForTable(false);
                setSnackbar({
                    open: true,
                    message: error.response?.data?.message || "Error fetching IMS report summary",
                    severity: 'error'
                });
            });
    };

const onClickRefresh = () => {
    setRefreshLoading(true);
    Promise.allSettled([
        new Promise((resolve) => {
            getApiImsRepository(reconid, pagination.page, pagination.rowsPerPage);
            resolve();
        }),
        new Promise((resolve) => {
            getManualLog();
            resolve();
        }),
    ]).finally(() => {
        setTimeout(() => setRefreshLoading(false), 600);
    });
}

    const handleBackClick = () => {
        history.push({
            pathname: `/IMSReconciliation_data/${reconid}`,
            state: {
                returnTab: 'imsReport',
                reconid: reconid
            }
        });
    };
    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };


    //     const handleBackClick = async () => {
    //     if (!reconId) {
    //         console.error('reconId is not available');
    //         history.push({
    //             pathname: '/IMSReconciliation_data',
    //             state: { returnTab: 'imsReport' }
    //         });
    //         return;
    //     }

    //     try {
    //         // Example API call with reconId
    //         const response = await axios.post('/some-endpoint', { recon_id: reconId });
    //         console.log('API response:', response.data);
    //         setSnackbar({
    //             open: true,
    //             message: response.data.message || 'Action completed',
    //             severity: 'success'
    //         });
    //     } catch (error) {
    //         console.error('Error in API call:', error);
    //         setSnackbar({
    //             open: true,
    //             message: error.response?.data?.message || 'Error performing action',
    //             severity: 'error'
    //         });
    //     }

    //     history.push({
    //         pathname: `/IMSReconciliation_data/${reconId}`,
    //         state: { 
    //             returnTab: 'imsReport',
    //             reconid: reconId
    //         }
    //     });
    // };


    return (
        <React.Fragment>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px' }}>
                <Typography
                    variant="h6"
                    sx={{
                        flex: 1,
                        textAlign: 'center',
                        letterSpacing: '0.04rem',
                        fontFamily: `'Montserrat', sans-serif`,
                        textTransform: 'uppercase',
                        color: '#1D3557',
                        fontWeight: 'bold',
                    }}
                >
                    IMS Manual Upload
                </Typography>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Tooltip title="Back" arrow>
                        <IconButton
                            color='warning'
                            onClick={handleBackClick}
                            // onClick={() => history.goBack()}
                            sx={{
                                borderRadius: '50%',
                                padding: '8px',
                                color: '#263238',
                                fontSize: '24px',
                                marginRight: '15px',
                                backgroundColor: '#ffffff',
                                '&:hover': {
                                    backgroundColor: '#455a64',
                                    color: '#ffffff',
                                },
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                                transition: 'background-color 0.3s ease',
                            }}
                        >
                            <ArrowBackIcon />
                        </IconButton>
                    </Tooltip>

                   <Tooltip title="Refresh" arrow>
    <IconButton
        color='warning'
        onClick={() => { if (!refreshLoading) onClickRefresh(); }}
        sx={{
            borderRadius: '50%',
            padding: '8px',
            color: '#3949ab',
            fontSize: '24px',
            marginRight: '15px',
            backgroundColor: '#ffffff',
            '&:hover': {
                backgroundColor: '#3949ab',
                color: '#ffffff',
            },
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
            transition: 'background-color 0.3s ease',
        }}
    >
        {refreshLoading ? (
            <CircularProgress size={20} sx={{ color: 'inherit' }} />
        ) : (
            <RefreshIcon />
        )}
    </IconButton>
</Tooltip>
                    <Tooltip title="Export" arrow>
                        <IconButton
                            color='success'
                            onClick={() => { if (!exportButtonLaoding && !loaderForTable) handleExportExcel(); }}
                            sx={{
                                borderRadius: '50%',
                                padding: '8px',
                                fontSize: '24px',
                                marginRight: '15px',
                                backgroundColor: '#ffffff',
                                '&:hover': {
                                    backgroundColor: '#ccff90',
                                    color: '#000000',
                                },
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                                transition: 'background-color 0.3s ease',
                            }}
                        >
                            {exportButtonLaoding ? (
                                <CircularProgress sx={{ color: '#1976d2', size: 20 }} size={20} />
                            ) : (
                                <img
                                    style={{ height: 24, width: 24, objectFit: 'contain' }}
                                    src='https://img.icons8.com/?size=48&id=117561&format=png'
                                    alt="Export Icon"
                                />
                            )}
                        </IconButton>
                    </Tooltip>
                </div>
            </div>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    fontFamily: "'Roboto', sans-serif",
                    width: "100%",
                    marginTop: '1%'
                }}
            >
                <ToggleSwitch
                    onChange={handleToggleChange} // Updated to use handleToggleChange
                    value={upload26AS}
                    label="Upload IMS"
                />
            </div>
            {upload26AS && (
                <Box sx={{ width: '100%', margin: '0 auto', }}>
                    <div className={classes.uploadSection}>
                        <input
                            type="file"
                            accept=".xlsx, .xls, .csv"
                            onChange={handleFileChange}
                            className={classes.fileInput}
                            id="excel-upload-input"
                        />
                        <label htmlFor="excel-upload-input">
                            <Button variant="contained" component="span" className={classes.uploadButtonInput}>
                                <CloudUploadIcon className={classes.icon} />
                                Choose Excel File
                            </Button>
                        </label>
                        {selectedFile && (
                            <Typography className={classes.fileName} style={{ fontWeight: 'bold' }}>
                                {selectedFile.name}
                            </Typography>
                        )}
                        <Button onClick={handleFileUpload} className={classes.uploadButton}>
                            {isLoading ? (
                                <CircularProgress size={24} color="inherit" />
                            ) : (
                                <>
                                    <span style={{ color: '#ffffff' }}>Upload Excel</span>
                                    <TurnedInNotIcon className={classes.icon} style={{ color: '#ffffff' }} />
                                </>
                            )}
                        </Button>
                    </div>
                    <Box sx={{ marginBottom: '20px' }}>
                        <LogTable
                            recordForLogTable={recordForLogTable}
                            loaderForTable={loaderForTable}
                            handleActionClick={handleActionClick}
                            getManualLog={getManualLog}
                        />
                    </Box>
                </Box>
            )}
            <IMSReport
                recordForTable={recordForTable}
                loaderForTable={loaderForTable}
                gridApiRef={gridApiRef}
                getApiImsReport={() => reconId && getApiImsRepository(reconId, 0, pagination.rowsPerPage)}
                pagination={pagination}
                handlePageChange={handlePageChange}
                handleRowsPerPageChange={handleRowsPerPageChange}
            // handleStatus={handleStatus} // Add handleStatus prop
            // activeTab={activeTab}
            />

            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </React.Fragment>
    );
}
